import { Icon } from "rsuite";
import _ from "lodash";
import PropTypes from "prop-types";
import React, { useContext } from "react";
import { createUseStyles } from "react-jss";
import Slider from "react-slick";
import { ServiceTypes } from "../../ListProduct/helpers";
import {
  extractImagesFromPkg,
  StyleTypeContext,
} from "../../../umbilical_tools";
import SliderArrow from "../SliderArrows";
import jssVariables from "../../../jss_setup";
import RatingPanel from "../RatingPanel";
import { getAddOnImgs } from "../../ListProduct/ProductStaticPkg";

const headerStyle = createUseStyles({
  header: (props) => ({
    position: "relative",
    display: "grid",
    alignContent: "end",
    gridGap: jssVariables.half_gap,
    width: "100%",
    height: `calc(100vh - ${jssVariables.navbar_height})`,
    color: jssVariables.colors.text.light,
    padding: "5vw",
    zIndex: 1,
    ..._.get(props, "customStyles.header", {}),
  }),
  slider: (props) => ({
    position: "absolute",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    ..._.get(props, "customStyles.slider", {}),
  }),
  img: (props) => ({
    width: "100%",
    height: `calc(100vh - ${jssVariables.navbar_height})`,
    zIndex: -1,
    objectFit: "cover",
    ..._.get(props, "customStyles.img", {}),
  }),
  title: (props) => ({
    justifySelf: "baseline",
    alignSelf: "center",
    textShadow: jssVariables.shadows.title_text_shadow,
    zIndex: 1,
    fontSize: "xxx-large",
    ..._.get(props, "customStyles.title", {}),
  }),
  destination: (props) => ({
    textShadow: jssVariables.shadows.title_text_shadow,
    zIndex: 1,
    ..._.get(props, "customStyles.destination", {}),
  }),
  rate: (props) => ({
    zIndex: 0,
    ..._.get(props, "customStyles.rate", {}),
  }),

  provider: (props) => ({
    zIndex: 1,
    position: "relative",
    ..._.get(props, "customStyles.provider", {}),
  }),
  provider_logo: (props) => ({
    border: `2px solid ${jssVariables.colors.base_color}`,
    borderRadius: "50%",
    width: "4rem",
    height: "4rem",
    objectFit: "scale-down",
    zIndex: 1,
    background: "white",
    padding: ".1rem",
    ..._.get(props, "customStyles.provider_logo", {}),
  }),
  provider_name: (props) => ({
    position: "absolute",
    color: jssVariables.colors.base_color,
    padding: `calc(${jssVariables.normal_gap} / 4) ${jssVariables.normal_gap}`,
    background: "white",
    borderRadius: "0 5px 5px 0",
    marginLeft: `calc(-0.5 * ${jssVariables.normal_gap})`,
    zIndex: -1,
    top: "50%",
    transform: "translateY(-50%)",
    width: "max-content",
    ..._.get(props, "customStyles.provider_name", {}),
  }),
  [`@media ${jssVariables.media.smallscreen}`]: {
    header: (props) => ({
      height: `calc(90vh - ${jssVariables.navbar_height})`,
      padding: `calc(${jssVariables.normal_gap} * 4)`,
      ..._.get(props, "customStyles.header.smallscreen", {}),
    }),
    img: (props) => ({
      height: `calc(90vh - ${jssVariables.navbar_height})`,
      ..._.get(props, "customStyles.img.smallscreen", {}),
    }),
    title: (props) => ({
      justifySelf: "start",
      alignSelf: "end",
      ..._.get(props, "customStyles.title.smallscreen", {}),
    }),
    provider_logo: (props) => ({
      border: `3px solid ${jssVariables.colors.base_color}`,
      width: "6rem",
      height: "6rem",
      ..._.get(props, "customStyles.provider_logo.smallscreen", {}),
    }),
  },
  [`@media ${jssVariables.media.bigscreen}`]: {
    bookbtn: (props) => ({
      display: "none",
      ..._.get(props, "customStyles.bookbtn.bigscreen", {}),
    }),
  },
});
const Header = ({ details, customStyles, isMarketplace, children }) => {
  const { type } = useContext(StyleTypeContext);

  const classes = headerStyle({ customStyles });

  var imgs = [];
  if (details.product_type === "PKG") {
    imgs = extractImagesFromPkg({ tour: details, size: "l" });
  } else {
    imgs = getAddOnImgs(details, { size: "xl" });
    if (!imgs.length) {
      imgs = getAddOnImgs(details, { size: "xl", include_items: true });
    }
  }

  const settings = {
    autoplay: false,
    auplaySpeed: 500,
    pauseOnHover: false,
    arrows: true,
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    nextArrow: <SliderArrow icon="fa:angle-right" />,
    prevArrow: <SliderArrow icon="fa:angle-left" />,
  };

  return (
    <div className={classes.header}>
      <span>
        <Slider className={classes.slider} {...settings}>
          {imgs &&
            imgs.map((img, idx) => (
              <img key={idx} className={classes.img} alt="" src={img} />
            ))}
        </Slider>
      </span>
      {type === "type2" && (
        <React.Fragment>
          <ServiceTypes
            tour={details}
            baseColor={jssVariables.colors.base_colorType2}
            customStyles={customStyles}
          />
          <div className={classes.destination}>
            {details.product_type === "PKG"
              ? _.get(details, "destinations", [])
                  .map((dest) => dest.name_en)
                  .join(" - ")
              : _.get(details, "destination.name_en", "")}
          </div>
        </React.Fragment>
      )}
      <div className={classes.title}>
        {details.product_type === "PKG"
          ? _.get(details, "content.pkgTitle.en", "")
          : _.get(details, "title", "")}
      </div>
      {type !== "type2" && (
        <h4 className={classes.destination}>
          <Icon icon="map-marker" size="2x" />{" "}
          {details.product_type === "PKG"
            ? _.get(details, "destinations", [])
                .map((dest) => dest.name_en)
                .join(" - ")
            : _.get(details, "destination.name_en", "")}
        </h4>
      )}
      <div className={classes.rate}>
        <RatingPanel
          rating={Number.parseInt(details.internal_rating)}
          color={jssVariables.colors.text.light}
          fontSize="x-large"
        />
      </div>
      {isMarketplace ? (
        <div className={classes.provider}>
          <img
            className={classes.provider_logo}
            src={_.get(
              details,
              "provider.logo.thumbnail_url",
              "https://apollo-statics.s3.eu-central-1.amazonaws.com/images/image_placeholder.jpg"
            )}
            alt={""}
          />
          <span className={classes.provider_name}>
            <strong>{_.get(details, "provider.name")}</strong>
          </span>
        </div>
      ) : null}
      {children}
    </div>
  );
};
Header.defaultProps = {
  customStyles: {},
  isMarketplace: false,
};
Header.propTypes = {
  customStyles: PropTypes.object.isRequired,
  details: PropTypes.object.isRequired,
  isMarketplace: PropTypes.bool,
  children: PropTypes.node,
};
export default Header;
